import React, { useState, useEffect } from 'react'; 

import { handleResponse } from '../../../../_helpers/handle-response';
import { DropdownDataService } from '../../../../_services/dropdownData.service';
import CONSTANTS from '../../../../_constants/constants';
import { parseFloat2Decimal, parseFloat2DecimalHeader } from '../../../../_helpers/utils';
import classes from './CustomerWiseAPIStockPage.module.css';

import Alert from '../../../UI/Alert/Alert';
import Button from '../../../UI/Button/Button';
import Loader from '../../../UI/Loader/Loader';
import Table from '../../../UI/Table/Table';
import ExportToCSV from '../../../UI/ExportToCSV/ExportToCSV';
import PageLayout from '../../../Layout/PageLayout/PageLayout';

const CustomerWiseAPIStockPage = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [fromDate, setFromDate] = useState(new Date().toISOString().slice(0,10));
    const [toDate, setToDate] = useState(new Date().toISOString().slice(0,10));
    const [customerId, setCustomerId] = useState('');
    const [customerData, setCustomerData] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [totalData, setTotalData] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [exportFileName, setExportFileName] = useState('');
    const [enableExport, setEnableExport] = useState(false);
    const [exportTotalData, setExportTotalData] = useState({});
    
    const tableHeaders = ['Customer', 'Opening Stock', 'Issued', 'Consumption', 'Adjustment', 'Closing Stock'];
    const dataFields = ['customerName', 'openingStock', 'issued', 'consumption', 'adjustment', 'closingStock'];
    const csvHeaders = [
        { label: 'Customer', key: 'customerName' },
        { label: 'Opening Stock', key: 'openingStock' },
        { label: 'Issued', key: 'issued' },
        { label: 'Consumption', key: 'consumption' },
        { label: 'Adjustment', key: 'adjustment' },
        { label: 'Closing Stock', key: 'closingStock' }
    ];
    const tableConfig = {
        headerAlignConfig: {
            'Customer': 'left', 
            'Opening Stock': 'center',
            'Issued': 'center',
            'Consumption': 'center',
            'Adjustment': 'center',
            'Closing Stock': 'center'
        },
        widthConfig: {
            'Customer': 'auto', 
            'Opening Stock': '154px',
            'Issued': '154px',
            'Consumption': '154px',
            'Adjustment': '154px',
            'Closing Stock': '154px'
        },
        alignConfig: {
            'customerName': 'left',
            'openingStock': 'right',
            'issued': 'right',
            'consumption' : 'right',
            'adjustment' : 'right',
            'closingStock': 'right'
        }
    };

    useEffect(() => {
        getCustomerList();
    }, []);

    useEffect(() => {
        setEnableExport(false);
        setErrorMessage(null);
    }, [fromDate, toDate, customerId]);

    const getCustomerList = () => {
        DropdownDataService.getCustomerList('filter').then( result => {
            if(result.data) {
                setCustomerId(result.data.results[0].customerId);
                setCustomerData(result.data.results);
            } else {
                setErrorMessage(result);
            }
        });
    }

    const getReportData = () => {
        const requestOptions = {
            headers: { 
                'Token': localStorage.getItem('accessToken'),
                'Content-Type': 'application/json'
            },
        };
        let url = customerId === '-1' ?
                `${CONSTANTS.API_URL}Reports/CustomerwiseAPIStockSummary?startDate=${fromDate}&endDate=${toDate}` :
                `${CONSTANTS.API_URL}Reports/CustomerwiseAPIStockSummary?startDate=${fromDate}&endDate=${toDate}&customerId=${customerId}`
        fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            (result) => {
                if(result.data) {
                    setIsLoading(false);
                    const keysToParse = ['openingStock', 'issued', 'consumption', 'adjustment', 'closingStock'];
                    parseFloat2Decimal(result.data.results, keysToParse);
                    setGridData(result.data.results);
                    setPageCount(Math.ceil(result.data.results.length/10));
                    let total = result.data.header;
                    const headerKeysToParse = ['openingStock', 'issued', 'consumption', 'adjustment', 'closingStock'];
                    parseFloat2DecimalHeader(total, headerKeysToParse);
                    setTotalData([
                        total.openingStock,
                        total.issued,
                        total.consumption,
                        total.adjustment,
                        total.closingStock
                    ]);
                    setExportTotalData({
                        customerName: 'Total',
                        openingStock: total.openingStock,
                        issued: total.issued,
                        consumption: total.consumption,
                        adjustment: total.adjustment,
                        closingStock: total.closingStock
                    });
                    setEnableExport(result.data.results.length > 0 ? true : false);
                } else {
                    setIsLoading(false);
                    setErrorMessage(result.error.message);
                }
            },
            error => {
                setIsLoading(false);
                setErrorMessage(error);
            }
        );
    }

    const showClickHandler = () => {
        setIsLoading(true);
        getReportData();
    }

    const viewClickHandler = rowData => {
        let detailedPage = window.open('/pavathi/customer-api-stock-detailed');
        detailedPage.startDate = fromDate;
        detailedPage.endDate = toDate;
        detailedPage.customerId = rowData.customerId;
        detailedPage.customerName = rowData.customerName;
    }

    const fromDateChangeHandler = event => setFromDate(event.target.value)
    
    const toDateChangeHandler = event => setToDate(event.target.value)

    const customerChangeHandler = event => setCustomerId(event.target.value)

    const getExportFileName = () => {
        let exportFilename = 'CustomerWiseAPIStock';
        exportFilename += '_' + fromDate;
        exportFilename += '_' + toDate;
        exportFilename += customerId !== '-1' ? '_' + customerData.find(data => data.customerId == customerId)['customerName'] : '';
        setExportFileName(exportFilename);
    }
    
    return (
        <>
            { isLoading && <Loader />}
            { !isLoading && (
                <PageLayout pageTitle='Customer Wise API Stock'>
                    <div className='row mb-1'>
                        <div className='col-12' style={{display: 'flex', justifyContent:'space-between', marginTop: '6px', marginBottom: '6px'}}>
                            <form className='form-inline'>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>From Date : </label>
                                    <input type='date' onKeyDown={(e) => e.preventDefault()} required className='form-control inputField' value={fromDate} onChange={fromDateChangeHandler} />
                                </div>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>To Date : </label>
                                    <input type='date' onKeyDown={(e) => e.preventDefault()} required className='form-control inputField' value={toDate} onChange={toDateChangeHandler} />
                                </div>
                                <div className={`form-group ${classes.inputContainer}`}>
                                    <label className='col-form-label inputLabel'>Customer : </label>
                                    <select className='form-select customSelect' value={customerId} aria-label=".form-select-sm example" onChange={customerChangeHandler}>
                                        { customerData.map( (value, index) => {
                                            return <option key={`customer-${index}`} className='dropdownItem' value={value.customerId}>{value.customerName}</option>
                                        }) }
                                    </select>
                                </div>
                            </form>
                            <div>
                                <Button btnClass='btn btn-primary mr-8' onClick={showClickHandler} btnText='Show' />
                                <ExportToCSV 
                                    headers={csvHeaders}
                                    exportTotalData={exportTotalData}
                                    gridData={gridData}
                                    exportFileName={exportFileName} 
                                    exportClickHandler={getExportFileName} 
                                    enableExport={enableExport}
                                />
                            </div>
                        </div>
                    </div>
                    { errorMessage && <Alert alertClassName='danger' message={errorMessage} /> }
                    <Table 
                        tableHeaders={tableHeaders} 
                        dataFields={dataFields} 
                        tableConfig={tableConfig}
                        pageCount={pageCount} 
                        sort={false}
                        actions={true} 
                        paginate={true}
                        filter={false}
                        view={true}
                        gridData={gridData}
                        totalData={totalData}
                        onRowClick={viewClickHandler}
                    />
                </PageLayout>
            )}    
        </>
    );
  
}

export default CustomerWiseAPIStockPage;